var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Netherlands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M42.716,31H5.284C8.125,38.588,15.421,44,24,44S39.875,38.588,42.716,31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M24,4C15.421,4,8.125,9.412,5.284,17h37.431C39.875,9.412,32.579,4,24,4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M44,24c0-2.467-0.468-4.818-1.284-7H5.284C4.468,19.182,4,21.533,4,24s0.468,4.818,1.284,7h37.431 C43.532,28.818,44,26.467,44,24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Netherlands);
export default __webpack_public_path__ + "static/media/icons8-netherlands.ae9d68191953d335d822ae7a708db949.svg";
export { ForwardRef as ReactComponent };